import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import settingLink from "./setting-link";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import SettingSidebar from "../../components/VerticalLayout/SettingSidebar";
import { addContactLevel, getContactLevel, updateContactLevel, deleteContactLevel } from "../../store/settings/Appointment/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

class ContactLevel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      level: ''
    }
    this.handleContactLevelSubmit = this.handleContactLevelSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (level) => {
    this.setState({ level: level });
    this.setState({ deleteModal: true });
  };

  handleDeleteContactLevel = () => {
    const { onDeleteContactLevel } = this.props;
    const { level } = this.state;
  
    if (level.id !== undefined) {
        onDeleteContactLevel(level);
      this.setState({ deleteModal: false });
    }
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  handleContactLevelSubmit(value) {
    this.props.addContactLevel(value, this.props.history);
  }

  componentDidMount() {
    const { onGetContactLevel } = this.props;
    onGetContactLevel(localStorage.getItem('userId'));
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { levels } = this.props;
    if (!isEmpty(levels) && size(prevProps.levels) !== size(levels)) {
      this.setState({ levels: {}, isEdit: false });
    }
  }
  toggleRightCanvas() {
    this.setState({ level: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const level = arg;
    this.setState({
        level: {
        id: level.id,
        contactLevelId: level.contactLevelId,
        contactLevelTitle: level.contactLevelTitle,
        agentId: level.agentId
      },
      isEdit: true,
    });
    this.toggle();
  };
  render() {
    const { levels, onUpdateAppContactLevel } = this.props;
    const { isEdit, deleteModal } = this.state;
    const level = this.state.level;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteContactLevel}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <MetaTags>
            <title>Agent Profile | Realty Space</title>
          </MetaTags>
          <Container fluid>


            <Row className="mb20">
              <Col xl="6">
                <Breadcrumbs
                  title={this.props.t("Agent")}

                  breadcrumbItem={this.props.t("Contact Level")}
                />

              </Col>

            </Row>
            <Row>
              <Col xl="3">
                <SettingSidebar />
              </Col>

              <Col xl="9">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    contactLevelTitle: (this.state && this.state.contactLevelTitle) || "",

                  }}
                  validationSchema={Yup.object().shape({
                    contactLevelTitle: Yup.string().required("This is required"),


                  })}

                  onSubmit={this.handleContactLevelSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >



                      <Card>
                        <CardBody>
                          <h5 className="card-title">Contact Lavel</h5>
                          <Row>


                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="contactLevelTitle">
                                  {this.props.t("Title *")}
                                </Label>
                                <SafeField
                                  name="contactLevelTitle"
                                  onChange={handleChange}

                                  type="text"

                                  className={
                                    "form-control" +
                                    (errors.contactLevelTitle && touched.contactLevelTitle
                                      ? " is-invalid"
                                      : "")
                                  }

                                  id="contactLevelTitle"
                                />
                                <ErrorMessage
                                  name="contactLevelTitle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>

                            </Col>

                            <Col sm="2">
                              <button type="submit" className="btn btn-primary w-md float-left" style={{ marginTop: 31 }}>Add</button>
                            </Col>

                          </Row>


                        </CardBody>
                      </Card>
                      <Card>
                        <CardBody>
                          <h5 className="card-title">History</h5>
                          <div className="table-responsive">
                            <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                              <thead className="">
                                <tr>
                                  <th>#</th>
                                  <th>Title</th>


                                  <th>Action</th>


                                </tr>
                              </thead>
                              <tbody>
                                {map(levels, (level, levelkey) => (
                                  <tr key={"_list_" + levelkey}>
                                    <th>{levelkey + 1}</th>
                                    <td>{level.contactLevelTitle}</td>
                                    <td>
                                      <ActionEdit onClick={() => this.toggleRightCanvas(level)} />
                                                                                                                                                                                                                                                                                                                                                                                                                              
                                      <ActionDelete onClick={() => this.onClickDelete(level)} />
                                   

                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </CardBody>
                      </Card>








                    </Form>
                  )}
                </Formik>




              </Col>

            </Row>
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: level.id,
                    contactLevelId: level.contactLevelId,
                    contactLevelTitle: level.contactLevelTitle,
                    agentId: level.agentId

                  }}
                  validationSchema={Yup.object().shape({
                    contactLevelTitle: Yup.string().required("This is required"),


                  })}

                  onSubmit={values => {

                    if (isEdit) {
                      const updateData = {
                        id: values.id,
                        contactLevelId: values.contactLevelId,
                        contactLevelTitle: values.contactLevelTitle,
                        agentId: values.agentId
                      };
                      onUpdateAppContactLevel(updateData);
                    } else {

                    }
                    this.toggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >




                      <Row>


                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="contactLevelTitle">
                              {this.props.t("Title *")}
                            </Label>
                            <SafeField
                              name="contactLevelTitle"
                              onChange={handleChange}

                              type="text"

                              className={
                                "form-control" +
                                (errors.contactLevelTitle && touched.contactLevelTitle
                                  ? " is-invalid"
                                  : "")
                              }

                              id="contactLevelTitle"
                            />
                            <ErrorMessage
                              name="contactLevelTitle"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                        </Col>

                        <Col sm="12">
                          <button type="submit" className="btn btn-primary w-md float-left">Update</button>
                        </Col>

                      </Row>



                    </Form>
                  )}
                </Formik>
              </OffcanvasBody>
            </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ContactLevel.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  loading: PropTypes.object,
  addContactLevel: PropTypes.func,
  onGetContactLevel: PropTypes.func,
  levels: PropTypes.array,
  onDeleteContactLevel: PropTypes.func,
  onUpdateAppContactLevel: PropTypes.func


}
const mapStateToProps = ({ AppoinmentObject }) => (
  {

    levels: AppoinmentObject.levels,
    loading: AppoinmentObject.loading

  })
const mapDispatchToProps = dispatch => ({

  addContactLevel: (data) => dispatch(addContactLevel(data)),
  onGetContactLevel: (agentId) => dispatch(getContactLevel(agentId)),
  onDeleteContactLevel: (id) => dispatch(deleteContactLevel(id)),
  onUpdateAppContactLevel: (data) => dispatch(updateContactLevel(data)),

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactLevel))
